const managePromotion = {
  managePromotion: {
    pageTitle: 'Manage Promotion',
    description: 'Add, edit, delete, and manage the activation status of promotions.',
    searchPlaceholder: 'Search by title or description',
    buttons: {
      reset: 'Reset',
      deleteSelected: 'Delete Selected {{count}}',
      addPromotion: 'Add Promotion',
      edit: 'Edit',
      delete: 'Delete'
    },
    imageFallback: {
      loadFailed: 'Load Failed',
      checkNetwork: 'Check Network Tab',
      loading: 'Loading...',
      noImage: 'No Image'
    },
    alerts: {
      saveFailed: 'Failed to save. Please try again.',
      deleteFailed: 'Failed to delete. Please try again.',
      statusUpdateFailed: 'Failed to update status. Please try again.',
    }
  }
};

export default managePromotion;